<template>
    <iframe 
        frameborder="0" height="600px" width="100%"
        src="https://docs.google.com/document/d/e/2PACX-1vTauPGwbis_AQeAFON4m7PR5x_7pgGnKFq-BWQcTinvJYG3U9YA3kBSAtU5zXju_Q/pub?embedded=true"
    >
    </iframe>
</template>

<script>
export default {
    setup() {  
    },
}
</script>
